module.exports = __webpack_public_path__ + "static/media/banner-orange-footer.8a8efa38.png";